import { useTranslation } from "react-i18next";
import { Alert } from "@/components/ui/alert";

export function TrialBanner() {
  const { t } = useTranslation();

  return (
    <Alert className="mb-6 border-primary/20 bg-primary/5">
      <div className="flex items-center gap-3">
        <div className="text-3xl">🎉</div>
        <div>
          <div className="font-semibold text-primary">
            {t("trial.days")} {t("trial.title")}
          </div>
          <div className="text-sm text-muted-foreground">
            {t("trial.description")}
          </div>
        </div>
      </div>
    </Alert>
  );
}
